<template >
  <div class="new-home-service">
    <h2 v-if="isDesktop">Testaankoop, tot je dienst</h2>
      <br v-if="isMobile"/>
    <div class="icons">
      <div class="icon-container">
        <img src="/images/nl_new_home/Atom/Icon/65ans.png" alt="" width="58" height="58" />
          <h3>Meer dan 65 jaar</h3>
        <p class="text-uppercase">expertise</p>
      </div>
      <div class="icon-container">
        <img src="/images/nl_new_home/Atom/Icon/belgium.png" alt="" width="58" height="58" />
          <h3>De grootste</h3>

          <p class="text-uppercase">
            <span class="desktop-icon-text">
                consumentenorganisatie <br> in België
            </span>
            <span class="mobile-icon-text">
                consumenten-organisatie in België
            </span>
        </p>
      </div>
      <div class="icon-container independant">
        <img src="/images/nl_new_home/Atom/Icon/trust.png" alt="" width="58" height="58"  />
          <h3>Onafhankelijk</h3>
        <p class="text-uppercase">van lobby’s of<br> merken</p>
      </div>
    </div>

    <p class="description line-height">
        Testaankoop is een vereniging die de consumenten in België informeert, verdedigt en vertegenwoordigt. Wij werken in volledige
      <strong>onafhankelijkheid</strong> zowel op financieel, politiek als ideologisch vlak. Daarom geeft je ons lidmaatschap
      <strong
        >een voordeelpakket waarmee je geld kunt besparen, jezelf kunt beschermen en meer te weten kunt komen over een groot aantal onderwerpen.</strong
      >
    </p>
      <img class="open-box" :src="service_image" alt="" />
      <img class="open-box-m" :src="service_image_mobile" alt="" />
  </div>
</template>
<script>
import image_mixin from "../../_commons/nl/mixins/image_mixin";



export default {
    mixins:[image_mixin],
    computed: {
        isMobile() {
            return window.innerWidth <= 768;
        },
        isDesktop() {
            return !this.isMobile;
        },
    }
};
</script>
